<template>
  <div style="padding: 10px">
    <el-form ref="form" :model="form" label-width="100px" size="small">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>连线信息</span>
        </div>
        
        <el-form-item label="连线名称">
          <el-input v-model="form.displayName" placeholder="请输入连线名称"></el-input>
        </el-form-item>
        
        <el-form-item label="条件表达式">
          <el-input 
            v-model="form.condition" 
            type="textarea" 
            :rows="3"
            placeholder="例如: status === 'approved'"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="优先级">
          <el-input-number 
            v-model="form.priority" 
            :min="0" 
            :step="1"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        
        <el-form-item label="备注">
          <el-input 
            v-model="form.remark" 
            type="textarea" 
            :rows="2"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        displayName: '',
        condition: '',
        priority: 0,
        remark: '',
        ...this.value
      }
    }
  },
  watch: {
    form: {
      handler(n) {
        this.$emit('input', n)
      },
      deep: true
    },
    value: {
      handler(n) {
        this.form = { ...this.form, ...n }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.box-card {
  border-radius: 8px;
  margin-bottom: 20px;
}

.clearfix {
  font-size: 16px;
  font-weight: bold;
}
</style>
